import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppService} from '../../../core/services/app.service';

@Injectable({
    providedIn: 'root'
})
export class RatingService {
    ratingUrl = AppService.getApiUrl() + '/api/ratings';

    constructor(private http: HttpClient) {
    }

    ratePhoto(ratingObj) {
        return this.http.post(this.ratingUrl, ratingObj);
    }

    updateRating(ratingObj, ratingId) {
        return this.http.put(this.ratingUrl + '/' + ratingId, ratingObj);
    }
    
    removeComment(ratingId) {
        return this.http.delete(this.ratingUrl + '/' + ratingId);
    }

    getRatingByPhoto(photoId) {
        const url = this.ratingUrl + `?filter[where][photoId]=${photoId}&filter[include][customer]&filter[order]=id%20DESC`;
        return this.http.get(url);
    }
}
